import React from 'react';
import ProcessSelection from './ProcessSelection';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser,logout } from '../actions/AppActions';

 
class ListaProcessos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            processos:[]
        }
        this.videoRef = React.createRef();

        // this.videoRef=null;
    }
    componentDidMount() {
        this.get_processos();
        this.logs_timeout = setTimeout(() => {
            this.salvar_log();
        }, 240000);
    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
    }

    async get_processos() {
        this.setState({loading_screen:true});
        fetch(`${URL}api/avaliador/get_processos/`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
    
            'Authorization': `Bearer ${this.props.token}`,
            // 'Content-Type': 'application/json',
          }
        }).then(async (responseLog) => {
          try {
            let resp = await responseLog.json();
            console.log(resp);
            if (resp.message == "Unauthenticated.") {
              localStorage.removeItem('token');
              // this.setState({redirect:true,path:'/'});
              this.props.logout();
            }
            if (resp.errors != null || resp.error != null) {
              let errors = Object.values(resp.errors);
              let erro = '';
              for (let i = 0; i < errors.length; i++) {
                if (i != errors.length - 1)
                  erro += errors[i] + '\n';
                else
                  erro += errors[i];
              }
              console.log(erro);
    
              // this.props.mudarLoadingHome(false);
              setTimeout(()=>{
                this.get_processos();
              },5000);
            }
            else {
                this.setState({loading_screen:false,processos:resp.processos});
    
            }
    
    
    
    
          } catch (err) {
            console.log(err);
            // this.props.mudarLoadingHome(false);
            setTimeout(()=>{
              this.get_processos();
            },5000);
    
          }
    
        })
          .catch((err) => {
            console.log(err);
            // this.props.mudarLoadingHome(false);
            setTimeout(()=>{
              this.get_processos();
            },5000);
          });
      }
    

    salvar_log() {
        fetch(`${URL}api/avaliador/salvar_log?screen=lista`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 240000);
                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }




   

  

   

    render() {
        return <ProcessSelection processos={this.state.processos} loading={this.state.loading_screen} faculdade={this.props.faculdade} user={this.props.user} />;
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser,logout })(ListaProcessos);
